var GetTileY = function (worldX, worldY) {
    return this.getTileXY(worldX, worldY, true).y;
}

export default GetTileY;